<label
  class="{{ labelBaseClass }}"
  [class.required]="isRequired"
  [class.disabled]="disabled"
>
  <input
    type="checkbox"
    class="{{ inputClass }}"
    [(ngModel)]="value"
    (ngModelChange)="onValueChanged()"
  />
  <span>
    <ng-content></ng-content>
  </span>
</label>
